import Vue from 'vue'

import Approvals from '@/views/Approvals'
import Auth from '@/views/Auth/Auth'
import Auto_add from '@/views/Autopark/Auto-add'
import Auto_list from '@/views/Autopark/Auto-list'
import Calculator from '@/views/Calculator'
import CallCenter from '@/views/CallCenter'
import CallCenterContacts from '@/views/CallCenter/Contacts'
import ClientsSettings from '@/views/ClientsSettings'
import CompanyCard from '@/views/Company/CompanyCard'
import Contragents from '@/views/Contragents/Contragent-list'
import Documents from '@/views/Documents/Documents'
import Driver_add from '@/views/Driver/Driver-add'
import Driver_list from '@/views/Driver/Driver-list'
import EdmUsers from '@/views/EdmUsers/EdmUsers'
import Flights from '@/views/Flights/Flights'
import Groups from '@/views/Contragents/Groups'
import Home from '@/views/Home/Home'
import Infographic from '@/views/Infographic/Infographic'
import Intro from '@/views/Intro/Intro'
import LoadDay from '@/views/LoadDay/LoadDay'
import ManagerAdd from '@/views/Managers/ManagerAdd'
import Managers from '@/views/Managers/Managers'
import OrganizationEdit from '@/views/User/Organization-edit'
import Page404 from '@/views/Page404/Page404'
import PoleCoefficients from '@/views/PoleCoefficients/PoleCoefficients.vue'
import PoleRf from '@/views/PoleRF/PoleRf.vue'
import Privacy from '@/views/Privacy/Privacy'
import RegisterOfPayments from '@/views/RegisterOfPayments/RegisterOfPayments'
import Report from '@/views/Report/Report'
import Reports from '@/views/Reports/Reports'
import Router from 'vue-router'
import ShippingAdd from '@/views/Home/Shipping/ShippingAdd'
import TableOfPayments from '@/views/TableOfPayments/TableOfPayments'
import Terms from '@/views/Terms/Terms'
import UnknownFiles from '@/views/UnknownFiles'
import User from '@/views/User/User'
import UserOrganizationsList from '@/views/UserOrganizations/UserOrganizationsList'
import Users from '@/views/Users/Users'

/** Роуты для нового интерфейса водителя **/
/** кроме них, у водителя используется общий Home **/
import AutosMobile from '@/views/AutosMobile'
import DriversMobile from '@/views/DriversMobile'
import FlightMobile from '@/views/FlightMobile/FlightMobile'
import FlightsMobile from '@/views/FlightsMobile'
import HelpMobile from '@/views/HelpMobile/HelpMobile'
import MoreItemsMobile from '@/views/MoreItemsMobile/MoreItemsMobile'
import ProfileMobile from '@/views/ProfileMobile/ProfileMobile'

/** Обработка ошибок при дублировании роута **/
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro,
    },
    {
      path: '/login',
      name: 'Login',
      component: Auth,
    },
    {
      path: '/organization-edit',
      name: 'OrganizationEdit',
      props: true,
      component: OrganizationEdit,
    },
    {
      path: '/user',
      name: 'User',
      component: User,
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports,
    },
    {
      path: '/report/:reportId/bid/:bidId',
      name: 'Report',
      component: Report,
    },
    {
      path: '/bid/:bidId/load-day/:loadDayId',
      name: 'LoadDay',
      component: LoadDay,
    },
    {
      path: '/shipping/add',
      name: 'Shipping Add',
      component: ShippingAdd,
    },
    {
      path: '/userorganizations/list',
      name: 'User-organizations',
      component: UserOrganizationsList,
    },
    {
      path: '/auto/list',
      name: 'Auto-list',
      props: true,
      component: Auto_list,
    },
    {
      path: '/auto/add',
      name: 'Auto-add',
      component: Auto_add,
    },
    {
      path: '/auto-add-mobile',
      name: 'AutoAddMobile',
      component: Auto_add,
    },
    {
      path: '/contragents',
      name: 'Contragents',
      component: Contragents,
    },
    {
      path: '/flights',
      name: 'Flights',
      component: Flights,
    },
    {
      path: '/driver/list',
      name: 'Driver-list',
      props: true,
      component: Driver_list,
    },
    {
      path: '/driver/add',
      name: 'Driver-add',
      component: Driver_add,
    },
    {
      path: '/driver-add-mobile',
      name: 'DriverAddMobile',
      component: Driver_add,
    },
    {
      path: '/contragents/group',
      name: 'Contragents Group Add',
      title: 'Добавление Групп контрагентов',
      component: Groups,
    },
    {
      path: '/documents',
      name: 'Documents',
      component: Documents,
    },
    {
      path: '/register-of-payments',
      name: 'RegisterOfPayments',
      component: RegisterOfPayments,
    },
    {
      path: '/table-of-payments',
      name: 'TableOfPayments',
      component: TableOfPayments,
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
    },
    {
      path: '/managers',
      name: 'Managers',
      component: Managers,
    },
    {
      path: '/managers/add',
      name: 'Manager-add',
      component: ManagerAdd,
    },
    {
      path: '/edm-users/',
      name: 'EdmUsers',
      component: EdmUsers,
    },
    {
      path: '/company',
      name: 'CompanyCard',
      component: CompanyCard,
    },
    {
      path: '/approvals',
      name: 'Approvals',
      component: Approvals,
    },
    {
      path: '/infographic',
      name: 'Infographic',
      component: Infographic,
    },

    {
      path: '/clients-settings',
      name: 'ClientsSettings',
      component: ClientsSettings,
    },
    {
      path: '/call-center',
      name: 'CallCenter',
      component: CallCenter,
    },
    {
      path: '/call-center/contacts',
      name: 'CallCenterContacts',
      component: CallCenterContacts,
    },
    {
      path: '/calculator',
      name: 'Calculator',
      component: Calculator,
    },
    {
      path: '/unknown-files',
      name: 'UnknownFiles',
      component: UnknownFiles,
    },
    {
      path: '/pole',
      name: 'Pole',
      component: PoleRf,
    },
    {
      path: '/pole-coefficients',
      name: 'PoleCoefficients',
      component: PoleCoefficients,
    },

    /** Роуты для нового интерфейса водителя **/
    /** кроме них, у водителя используется общий Home **/
    {
      path: '/autos-mobile',
      name: 'AutosMobile',
      component: AutosMobile,
    },
    {
      path: '/drivers-mobile',
      name: 'DriversMobile',
      component: DriversMobile,
    },
    {
      path: '/flights-mobile',
      name: 'FlightsMobile',
      component: FlightsMobile,
    },
    {
      path: '/flights-mobile/:type/:id',
      name: 'FlightMobile',
      component: FlightMobile,
    },
    {
      path: '/help-mobile',
      name: 'HelpMobile',
      component: HelpMobile,
    },
    {
      path: '/more-items',
      name: 'MoreItemsMobile',
      component: MoreItemsMobile,
    },
    {
      path: '/profile-mobile',
      name: 'ProfileMobile',
      component: ProfileMobile,
    },
    /* Пользовательское соглашение и Политика конфиденциальности */
    {
      path: '/Terms',
      name: 'Terms',
      component: Terms,
    },
    {
      path: '/Privacy',
      name: 'Privacy',
      component: Privacy,
    },
    {
      path: '*',
      name: 'Page404',
      component: Page404,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const authRequired = to.path === '/login'
  const unauthorisedPages = ['Terms', 'Privacy', 'Intro']
  const adminPages = ['/users', '/calculator', '/pole', '/pole-coefficients']
  const adminRequired = adminPages.includes(to.path)
  const loggedIn = localStorage.getItem('auth-token')
  const admin = Boolean(
    localStorage.getItem('admin-token') || localStorage.getItem('ceo-token'),
  )
  const userProfile = JSON.parse(localStorage.getItem('port_user_profile'))

  if (!authRequired && !loggedIn && !unauthorisedPages.includes(to.name)) {
    return next('/intro')
  }
  /** кастомная авторизация с фиксированным токеном **/
  if (authRequired && to.query && to.query.token) {
    return next()
  }

  /** Редирект для менеджера**/
  const managerPages = ['/user', '/home', '/flights', '/unknown-files']

  if (
    userProfile &&
    userProfile.user_type === 5 &&
    !managerPages.includes(to.path)
  ) {
    return next('/home')
  }

  if (authRequired && loggedIn) {
    return next('/home')
  }

  if (
    adminRequired &&
    loggedIn &&
    (!admin || (userProfile && ![1, 6].includes(userProfile.user_type)))
  ) {
    return next('/home')
  }

  next()
})

export default router
